import React from 'react';
import { useTranslation } from 'react-i18next';
import { createPlaceholderUrl } from '../../../../utils/PlaceholderCreator';

import { calculateUniqueSkillScore } from '../../../Calculations/UniqueSkillScoreCalculator';

const CharacterData = ({
    uniqueSkill,
    uniqueSkillLevel,
    setUniqueSkillLevel,
    potentialLevel,
    setPotentialLevel,
    selectedStars
}) => {
    const { t } = useTranslation();

    // Helper to get icon URL
    const getSkillIconUrl = (iconId) => {
        if (!iconId) return null;
        return `/images/Icon/Skill_Icons/icon_skill_${iconId}.png`;
    };

    const uniqueScore = calculateUniqueSkillScore(selectedStars, uniqueSkillLevel);

    return (
        <div className="bg-white rounded-2xl shadow-lg p-5">
            <h3 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2">{t('AppCharacterData.title_config')}</h3>

            <div className="space-y-6">
                {/* Unique Skill Section */}
                <div>
                    <h4 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Unique Skill</h4>
                    {uniqueSkill ? (
                        <div className="flex items-start gap-4">
                            {/* Icon */}
                            <div className="w-16 h-16 bg-gray-100 rounded-lg flex-shrink-0 overflow-hidden border border-gray-200">
                                <img
                                    src={getSkillIconUrl(uniqueSkill.icon_id)}
                                    alt={uniqueSkill.Skill_name}
                                    className="w-full h-full object-cover"
                                    onError={(e) => { e.target.src = createPlaceholderUrl(64, 64, 'Skill'); }}
                                />
                            </div>

                            {/* Info & Level */}
                            <div className="flex-1">
                                <div className="mb-2">
                                    <div className="font-bold text-gray-800 text-lg leading-tight">{uniqueSkill.Skill_name}</div>
                                    <div className="text-xs text-gray-400">{uniqueSkill.Skill_name_jp}</div>
                                </div>

                                <div className="flex items-center gap-4">
                                    <div className="flex items-center gap-2">
                                        <label className="text-sm text-gray-600 font-medium">{t('AppCharacterData.label_level')}</label>
                                        <select
                                            value={uniqueSkillLevel}
                                            onChange={(e) => setUniqueSkillLevel(parseInt(e.target.value))}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-1.5"
                                        >
                                            {[1, 2, 3, 4, 5, 6].map(lvl => (
                                                <option key={lvl} value={lvl}>Lv {lvl}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {uniqueScore > 0 && (
                                        <div className="flex items-center gap-1 bg-green-50 px-2 py-1 rounded border border-green-100">
                                            <span className="text-xs text-gray-500 font-medium">Score:</span>
                                            <span className="text-sm font-bold text-green-600">{uniqueScore}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-gray-400 italic text-sm p-2 bg-gray-50 rounded">
                            {t('AppCharacterData.msg_no_unique')}
                        </div>
                    )}
                </div>

                {/* Potential Section */}
                <div>
                    <h4 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">{t('AppCharacterData.title_potential')}</h4>
                    <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg border border-gray-200">
                        <span className="text-gray-700 font-medium">{t('AppCharacterData.label_awakening')}</span>
                        <div className="flex items-center gap-2">
                            <select
                                value={potentialLevel}
                                onChange={(e) => setPotentialLevel(parseInt(e.target.value))}
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-24 p-2"
                            >
                                {[1, 2, 3, 4, 5].map(lvl => (
                                    <option key={lvl} value={lvl}>Lv {lvl}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <p className="text-xs text-gray-400 mt-2">
                        {t('AppCharacterData.helper_potential')}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CharacterData;
// Revisado: 2025-12-16
